module.exports = __webpack_public_path__ + "img/clinica_colosio.a8f9a198.png";